import { memo } from "react"
import "../index.scss";
import CustomScroll from '@src/component/customScroll';
import BottomIcon from "@src/component/bottomIcon";
import successIcon from "@src/assets/image/rzIndex/success.png"
const StatePending = () => {

  return (
    <div className="page bottomFit rzStatus">
      <CustomScroll>
        <div className="rePending">
        <img src={successIcon} alt=""></img>
          <p>您的资格预审正在处理中</p>
        </div>
        <div className="pending-text">
          <div className="text-title">便于您更快捷的办理租金分期业务，请提前准备以下资料：</div>
          <ul>
            <li>
              <p><i />摩托车驾照</p>
              <span>没有摩托车驾照不能放款</span>
            </li>
            <li>
              <p><i />征信-人行征信电子版</p>
              <span>手机银行APP可申请</span>
            </li>
            <li>
              <p><i />工作证明（以下六选一即可）</p>
              <p className="p-conent"><span>职员：</span>纳税明细查询截屏/公积金截屏/社保截屏/工资流水/企业微信或钉钉打卡记录截屏（截图中需显示单位名称）</p>
              <p className="p-conent"><span>企业主：</span>营业执照照片（注册满6个月）</p>
            </li>
            <li>
              <p><i />近6个月工资（经营）流水</p>
              <p className="p-conent"><span>职员：</span>网银工资或收入流水（截图中需显示姓名）</p>
              <p className="p-conent"><span>企业主：</span>电子版经营流水即可</p>
            </li>
          </ul>
        </div>
      </CustomScroll>
      <BottomIcon/>
    </div>

  )
}

export default memo(StatePending);